/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const FOLDER_CLEAN_REQUEST = 'FOLDER_CLEAN_REQUEST';
export const FOLDER_SINGLE_CLEAN_REQUEST = 'FOLDER_SINGLE_CLEAN_REQUEST';

export const FOLDER_UPSERT_REQUEST = 'DOCUMENT_FOLDER_UPSERT_REQUEST';
export const FOLDER_UPSERT_REQUEST_SUCCESS = 'DOCUMENT_FOLDER_UPSERT_REQUEST_SUCCESS';
export const FOLDER_UPSERT_REQUEST_FAILURE = 'DOCUMENT_FOLDER_UPSERT_REQUEST_FAILURE';

export const FOLDER_FETCH_REQUEST = 'FOLDER_FETCH_REQUEST';
export const FOLDER_FETCH_REQUEST_SUCCESS = 'FOLDER_FETCH_REQUEST_SUCCESS';
export const FOLDER_FETCH_REQUEST_FAILURE = 'FOLDER_FETCH_REQUEST_FAILURE';

export const FOLDER_DOCUMENT_CLEAN_REQUEST = 'FOLDER_DOCUMENT_CLEAN_REQUEST';
export const FOLDER_DOCUMENT_SINGLE_CLEAN_REQUEST = 'FOLDER_DOCUMENT_SINGLE_CLEAN_REQUEST';

export const FOLDER_DOCUMENT_UPSERT_REQUEST = 'FOLDER_DOCUMENT_UPSERT_REQUEST';
export const FOLDER_DOCUMENT_UPSERT_REQUEST_SUCCESS = 'FOLDER_DOCUMENT_UPSERT_REQUEST_SUCCESS';
export const FOLDER_DOCUMENT_UPSERT_REQUEST_FAILURE = 'FOLDER_DOCUMENT_UPSERT_REQUEST_FAILURE';

export const FOLDER_DOCUMENT_FETCH_REQUEST = 'FOLDER_DOCUMENT_FETCH_REQUEST';
export const FOLDER_DOCUMENT_FETCH_REQUEST_SUCCESS = 'FOLDER_DOCUMENT_FETCH_REQUEST_SUCCESS';
export const FOLDER_DOCUMENT_FETCH_REQUEST_FAILURE = 'FOLDER_DOCUMENT_FETCH_REQUEST_FAILURE';

export const FETCH_FOLDER_YEAR_WISE = 'FETCH_FOLDER_YEAR_WISE';
export const FETCH_FOLDER_YEAR_WISE_SUCCESS = 'FETCH_FOLDER_YEAR_WISE_SUCCESS';
export const FETCH_FOLDER_YEAR_WISE_FAILURE = 'FETCH_FOLDER_YEAR_WISE_FAILURE';

export const DELETE_FOLDER_REQUEST = 'DELETE_FOLDER_REQUEST';
export const DELETE_FOLDER_REQUEST_SUCCESS = 'DELETE_FOLDER_REQUEST_SUCCESS';
export const DELETE_FOLDER_REQUEST_FAILURE = 'DELETE_FOLDER_REQUEST_FAILURE';
